import { ButtonAddHLPure, DialogAddUserPure, GridPure, SearchBarHLPure } from '../../pures'
import { Grid, useMediaQuery } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useMemo, useState } from 'react'

const UserAdministrationList = (props) => {
    // #region variables
    const {
        t,
        users,
        roles,
        createNewUser,
        updateUserStatus,
        setSelectedUser,
        clientAssistants,
        loadingClientAssistants
    } = props

    const { t: tCommon } = useTranslation('common')
    const hideActions = useMediaQuery('(max-width: 820px)')

    const [searchUser, setSearchUser] = useState('')
    const [showAddUserDialog, setShowAddUserDialog] = useState(false)
    // #endregion variables

    // #region effects
    const usersTransformed = useMemo(() => {
        return users.map(v => ({
            ...v,
            status: v.status === 'active' ? t('statusEnabled') : t('statusDisabled')
        }))
    }, [users, t])

    const userGrid = useMemo(() => {
        if (!searchUser) return usersTransformed;

        const lowercasedSearchUser = searchUser.toLowerCase()
        const filteredUsers = usersTransformed.filter(el => el.name.toLowerCase().includes(lowercasedSearchUser) ||
            el.email.includes(lowercasedSearchUser))
        return filteredUsers
    }, [usersTransformed, searchUser])

    // Roles generales (usuario / administrador) disponibles al invitar a alguien
    const roleOptions = useMemo(() => {
        const generalGroup = (roles || []).find(group => group.groupName === 'general')
        return (generalGroup?.roles || []).map(role => ({ id: role.id, label: t(role.key) }))
    }, [roles, t])
    // #endregion effects

    // #region methods
    const handleChangeSearch = (e) => setSearchUser(e.target.value);

    const handleCreateUser = async ({ email, roleId, assistantIds }) => {
        await createNewUser(email, roleId, assistantIds)
    }
    // #endregion methods

    return (
        <>
            <Grid item xs={12} className="add-and-search-container">
                <ButtonAddHLPure
                    iconAdd={true}
                    nameBtn={t("addUser")}
                    onClickBtn={() => setShowAddUserDialog(true)}
                />
                <SearchBarHLPure
                    placeholder={tCommon("search")}
                    onSearchChange={((e) => handleChangeSearch(e))}
                />
            </Grid>
            <Grid item xs={12}>
                <GridPure
                    {...props}
                    dataGrid={userGrid}
                    skip={0}
                    take={11}
                    rowsItems={[
                        {
                            field: 'name',
                            title: t('users'),
                            width: 200,
                            sorteable: true
                        },
                        {
                            field: 'email',
                            title: tCommon("mail"),
                            width: 200,
                            sorteable: true
                        },
                        {
                            field: 'status',
                            title: t('status'),
                            width: 100,
                            sorteable: true
                        },
                        {
                            field: 'Acciones',
                            title: tCommon('actions'),
                            width: hideActions ? 80 : 200,
                            actions: true,
                            headerClassName: 'actionHeader'
                        }]}
                    actions={[
                        {
                            type: 'view-details',
                            value: tCommon('details'),
                            onClick: (dataItem) => {
                                setSelectedUser(dataItem)
                            }
                        },
                        {
                            type: 'label',
                            value: (dataItem) => dataItem.active ? t('disable') : t('enable'),
                            onClick: (dataItem) => {
                                updateUserStatus(!dataItem.active, dataItem.email)
                            }
                        },
                    ]}
                />
            </Grid>

            {showAddUserDialog && (
                <DialogAddUserPure
                    onClose={() => setShowAddUserDialog(false)}
                    onSubmit={handleCreateUser}
                    roleOptions={roleOptions}
                    assistants={clientAssistants || []}
                    loadingAssistants={loadingClientAssistants}
                />
            )}
        </>
    )
}

export default UserAdministrationList